/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-right-3': {
    width: 10,
    height: 18,
    viewBox: '0 0 10 18',
    data: '<path d="M1 1L8.83927 8.62311C9.05358 8.83115 9.05358 9.16885 8.83927 9.37689L1 17" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
